var _desc, _defs, _rect, _rect2, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNikeCloneVue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 560",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Nike clone Vue thumbnail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Nike store hero page with red branding, large new arrival headline, yellow shoe product art, and product carousel cards.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoeGold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe23b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#f7c400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d99600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoeShadow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f172a",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f172a",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#eef0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dde2fb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 18,
    floodColor: "#1f2937",
    floodOpacity: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shoeGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 14,
    floodColor: "#d97706",
    floodOpacity: 0.32
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 0,
    width: 470,
    height: 560,
    fill: "url(#panel)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854 -24c-54 126-91 221-112 286-20 62-13 103 20 128 31 23 79 40 146 52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 62c-69 145-109 243-119 294-12 61 21 104 100 130"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 73c34-8 69-19 105-33-41 25-78 39-112 43-14 2-21-2-20-12 1-11 11-28 29-50-8 18-9 35-2 52Z",
    fill: "#ff5d52"
  }), /*#__PURE__*/React.createElement("text", {
    x: 128,
    y: 74,
    fill: "#ff5d52",
    fontSize: 33,
    fontWeight: 800
  }, "Nike"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 158,
    fill: "#ff5d52",
    fontSize: 25,
    letterSpacing: 1
  }, "Our Summer collections"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 285,
    fill: "#050505",
    fontSize: 92,
    fontWeight: 900
  }, "The New Arrival"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 390,
    fill: "#ff5d52",
    fontSize: 92,
    fontWeight: 900
  }, "Nike"), /*#__PURE__*/React.createElement("text", {
    x: 266,
    y: 390,
    fill: "#050505",
    fontSize: 92,
    fontWeight: 900
  }, "Shoes"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 459,
    fill: "#6b7280",
    fontSize: 23
  }, "Discover stylish Nike arrivals, quality"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 497,
    fill: "#6b7280",
    fontSize: 23
  }, "comfort, and innovation for active life."), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 522,
    width: 142,
    height: 46,
    rx: 23,
    fill: "#ff6257"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 552,
    fill: "#ffffff",
    fontSize: 20,
    fontWeight: 800
  }, "Shop now"), /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 545,
    r: 13,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 545h9m-4-5 5 5-5 5",
    fill: "none",
    stroke: "#ff6257",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shoeGlow)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 662,
    cy: 424,
    rx: 198,
    ry: 34,
    fill: "#0f172a",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484 148) rotate(-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 211c32 7 93 7 157 2 71-6 142-15 210 5 28 8 41 29 29 49-21 34-88 47-166 38-92-10-171-21-248-5-30 6-46-2-50-22-5-25 22-56 68-67Z",
    fill: "url(#shoeGold)",
    stroke: "#c28300",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 267c63 9 128 10 197 14 78 4 145 18 218-6-13 31-71 47-146 43-90-5-183-23-267-9-22 4-39-6-42-23-1-7 7-14 22-19Z",
    fill: "#d99a00",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 202c34-47 62-77 119-83l104-11c57-6 83 17 90 70l-83 4c-24-24-51-31-82-24l-76 18c-24 5-47 14-72 26Z",
    fill: "url(#shoeGold)",
    stroke: "#b77d00",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 118c-4-51 10-81 44-90 29 19 46 48 52 86Z",
    fill: "#e0a300",
    stroke: "#b77d00",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 108c5-48 21-75 50-83 35 22 52 63 43 150-29-36-58-58-93-67Z",
    fill: "#e7ad00",
    stroke: "#b77d00",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 181c39-16 91-25 155-20 37 3 72 9 104 19",
    fill: "none",
    stroke: "#fff37a",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 220c59 9 131 10 217 5 54-4 97 0 130 12",
    fill: "none",
    stroke: "#ffe666",
    strokeWidth: 5,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#8a5b00",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 173c18 8 28 21 30 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 165c17 9 27 23 31 43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 160c16 10 26 24 30 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 162c15 11 24 25 27 43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 167c15 10 23 23 25 39"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#172554"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339 213c23-18 47-36 75-55-16 34-37 59-64 75-8 5-16-12-11-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 209c19-12 38-23 58-33-8 22-24 38-49 49-8 4-15-10-9-16Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#a66d00",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 279c30 0 50 11 62 34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 281c24 7 39 19 46 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 283c20 8 32 20 37 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 286c18 9 29 21 33 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 292c18 9 30 20 37 34"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f7d039",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 47,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 55,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 69,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 45,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342,
    cy: 62,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 85,
    r: 6
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)",
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 505,
    width: 96,
    height: 42,
    rx: 12,
    fill: "#c4c8df",
    stroke: "#ff6257",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 505,
    width: 96,
    height: 42,
    rx: 12,
    fill: "#c4c8df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 505,
    width: 96,
    height: 42,
    rx: 12,
    fill: "#c4c8df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 507l-24 40M532 507l-24 40M640 507l-24 40M664 507l-24 40M772 507l-24 40M796 507l-24 40",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikeCloneVue);
export default __webpack_public_path__ + "static/media/nike-clone-vue.4cd0f2df04fe5c7f80d6e989d888098c.svg";
export { ForwardRef as ReactComponent };